import React from "react"
import Icon from "@ant-design/icons"
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon"

const UserSvg = () => {
    return   <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.64 22.73"
        xmlSpace="preserve"
        width="1em"
        height="1em"
    >
        <path
            d="M11.66 3.26h.59c.29.06.59.09.87.19 1.6.52 2.66 1.95 2.68 3.63.01 1.04-.35 1.94-1.07 2.7-.15.16-.33.31-.5.47.1.04.18.08.27.12 1.3.58 2.29 1.49 3 2.73.45.79.7 1.64.78 2.54.04.41.06.83-.09 1.23-.31.88-1.1 1.44-2.06 1.44H8.95c-.45 0-.89.02-1.34-.01-.82-.04-1.42-.44-1.81-1.17-.15-.28-.2-.58-.24-.88v-.15c.03-.1.04-.18.04-.27.03-.74.2-1.44.48-2.12.55-1.29 1.43-2.3 2.64-3.02.3-.18.61-.32.94-.48-.07-.06-.14-.11-.21-.17-.14-.14-.31-.28-.44-.44-.85-1.06-1.13-2.25-.75-3.55.39-1.35 1.3-2.22 2.64-2.64.24-.08.5-.11.76-.15zm.3 13.88c1.36 0 2.73-.01 4.09 0 .72.01 1.17-.49 1.1-1.14-.03-.29-.04-.58-.1-.86-.3-1.39-1.02-2.51-2.21-3.29-1.65-1.07-3.4-1.22-5.17-.34-1.89.94-2.85 2.52-2.92 4.63-.01.15.03.32.1.45.19.39.53.54.95.54 1.39.01 2.77.01 4.16.01zm-.01-12.73c-1.48 0-2.7 1.22-2.7 2.7 0 1.48 1.21 2.7 2.7 2.7 1.48 0 2.7-1.21 2.7-2.7 0-1.48-1.22-2.7-2.7-2.7z"
            style={{
                fill: "#787698",
            }}
        />
    </svg>
}

export const UserIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={UserSvg} {...props}/>
)
